import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgTemplateAssertTypeModule } from '@recruitee/common';

import { EmojiModule } from '@recruitee/emoji';
import {
  AvatarModule,
  ButtonModule,
  DropdownModule,
  FormFieldModule,
  HeadingModule,
  IconModule,
  InputModule,
  TooltipModule,
} from '@recruitee/user-interface';

import { ContextToolbarComponent } from './components/context-toolbar/context-toolbar.component';
import { LinkInputComponent } from './components/link-input/link-input.component';
import { MentionsComponent } from './components/mentions/mentions.component';
import { PmToolbarComponent } from './components/toolbar/toolbar.component';
import { WysiwgComponent } from './components/wysiwg/wysiwg.component';
import { ContextTooltipContainerDirective } from './directives/context-tooltip-container.directive';
import { RenderDirective } from './directives/render.directive';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    IconModule,
    InputModule,
    FormFieldModule,
    ReactiveFormsModule,
    OverlayModule,
    DropdownModule,
    AvatarModule,
    A11yModule,
    HeadingModule,
    TooltipModule,
    EmojiModule,
    NgTemplateAssertTypeModule,
  ],
  declarations: [
    WysiwgComponent,
    LinkInputComponent,
    ContextToolbarComponent,
    PmToolbarComponent,
    MentionsComponent,
    RenderDirective,
    ContextTooltipContainerDirective,
  ],
  exports: [
    WysiwgComponent,
    LinkInputComponent,
    ContextToolbarComponent,
    PmToolbarComponent,
    RenderDirective,
    ContextTooltipContainerDirective,
  ],
})
export class ProsemirrorModule {}
